export const normalizeCategoryUrl = (url = "") =>
  String(url)
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim()
    .replace(/^\/+|\/+$/g, "");

const nameAndPathKey = (name, path) => String(name) + " " + String(path);

const parentKey = (value) => (value === null || value === undefined ? " nullish" : String(value));

const EMPTY_INDEX = {
  byId: new Map(),
  byUrl: new Map(),
  byNameAndPath: new Map(),
  childrenByParent: new Map(),
};

export const buildCategoryIndex = (categories) => {
  if (!Array.isArray(categories) || categories.length === 0) return EMPTY_INDEX;

  const byId = new Map();
  const byUrl = new Map();
  const byNameAndPath = new Map();
  const childrenByParent = new Map();

  categories.forEach((category) => {
    if (!category) return;

    const id = String(category.categoryId);
    if (!byId.has(id)) byId.set(id, category);

    const url = normalizeCategoryUrl(category.url);
    if (!byUrl.has(url)) byUrl.set(url, category);

    const nameKey = nameAndPathKey(category.categoryName, category.eaPath);
    if (!byNameAndPath.has(nameKey)) byNameAndPath.set(nameKey, category);

    const parent = parentKey(category.parentCategory);
    const siblings = childrenByParent.get(parent);
    if (siblings) siblings.push(category);
    else childrenByParent.set(parent, [category]);
  });

  return { byId, byUrl, byNameAndPath, childrenByParent };
};

export const categoryById = (index, categoryId) => index?.byId.get(String(categoryId));

export const categoryByUrl = (index, url) => index?.byUrl.get(normalizeCategoryUrl(url));

export const categoryByNameAndPath = (index, name, path) =>
  index?.byNameAndPath.get(nameAndPathKey(name, path));

export const categoryChildrenOf = (index, categoryId) =>
  index?.childrenByParent.get(parentKey(categoryId)) ?? [];
